import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import PropTypes from 'prop-types';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function ContactsConfirmationRedirectButton({
  additionalUnitQuantity,
  offerId,
  activeTerm,
  seleniumId,
  ownsProduct,
  onClick = () => {},
  trackingSource,
  use,
  children,
  upgradeData,
  block,
  size,
  ['data-selenium']: dataSelenium = 'confirm-contacts-button',
  ['data-test-id']: dataTestId = 'confirm-contacts-button'
}) {
  const handleClick = () => {
    onClick({
      additionalUnitQuantity,
      offerId,
      activeTerm,
      ownsProduct,
      trackingSource
    });
  };
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: BILLING,
    modalType: REQUEST_SKU,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-id": `${trackingSource}-${seleniumId}-confirm-contacts-button`,
      "data-selenium": dataSelenium,
      "data-test-id": dataTestId,
      use: use,
      block: block,
      size: size,
      onClick: handleClick,
      target: "_blank",
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      },
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.pricingCtas.${ownsProduct ? 'buyAdditionalContacts' : 'buyNow'}`
      })
    })
  });
}
ContactsConfirmationRedirectButton.propTypes = {
  additionalUnitQuantity: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  seleniumId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ownsProduct: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  trackingSource: PropTypes.string.isRequired,
  use: PropTypes.string.isRequired,
  activeTerm: PropTypes.string,
  offerId: PropTypes.number,
  children: PropTypes.node,
  upgradeData: PropTypes.object.isRequired
};
export default ContactsConfirmationRedirectButton;